import { SvgIcon, type SvgIconProps } from './svgIcon'

export function GraphIcon2({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon width={width} height={height} viewBox="0 0 18 18" {...props}>
      <path
        d="M0.25 17.7496V16.1054L1.74995 14.6055V17.7496H0.25ZM4.25 17.7496V12.1054L5.74995 10.6055V17.7496H4.25ZM8.25 17.7496V10.6055L9.74995 12.1304V17.7496H8.25ZM12.25 17.7496V12.1304L13.75 10.6305V17.7496H12.25ZM16.25 17.7496V8.10542L17.75 6.60547V17.7496H16.25ZM0.25 12.2188V10.1054L6.99998 3.35544L11 7.35544L17.75 0.605469V2.71887L11 9.46884L6.99998 5.46884L0.25 12.2188Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
